module.exports = __webpack_public_path__ + "static/media/pic8.a8d17fb4.jpg";